<template>
  <div class="seo-text-wrapper">
    <div class="seo-text-content">
      <div v-show="!isSeoOpen && !isOnlyFullText">
        <span v-html="text.short"></span>
        <v-btn
            x-small
            plain
            icon
            @click="isSeoOpen = !isSeoOpen"
            elevation="0">
          <v-icon>mdi-dots-horizontal</v-icon>
        </v-btn>
      </div>

      <div v-show="isSeoOpen && !isOnlyFullText">
        <span v-html="text.full"></span>
        <v-btn
            x-small
            plain
            icon
            @click="isSeoOpen = false">
          <v-icon>mdi-window-minimize</v-icon>
        </v-btn>
      </div>

      <div v-if="isOnlyFullText && isPromo50">
        <span v-html="text.full"></span>
      </div>
      <div v-if="isOnlyFullText && !isPromo50">
        <span v-html="text.fullTextGigabit"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SeoTextToggle",
  props: {text: Object, isOnlyFullText: Boolean},
  mounted() {
    if (this.$route.query.a === 'x6w5Df') {
      this.isPromo50 = true;
    }
  },
  data() {
    return {
      isSeoOpen: false,
      isPromo50: false,
    }
  }
}
</script>

<style scoped>
.seo-text-wrapper {
  width: 100%;
  min-height: 125px;
  background-color: rgba(243, 243, 243, 0.99);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.seo-text-content {
  font-size: 12px;
  color: #999999;
  text-align: justify;
  padding: 15px 25px 15px 25px;
  width: 70%;
}
@media (max-width: 500px) {
  .seo-text-content {
    width: 100%;
  }
}
</style>